import { StyleRules, ListItemTextClassKey } from '@material-ui/core';
import colors from '../colors.module.scss';

export const MuiListItemText: Partial<StyleRules<ListItemTextClassKey, {}>> = {
  root: {
    color: colors.gray500,
  },
};
